import { LEADERSHIP_TAB_IDS } from '@/navigation/page-registry';

const ANDREW_ONLY_EMAIL = 'andrew.winter@trueclassic.com';

const ANDREW_ONLY_TAB_IDS = new Set<string>([
  // Dashboards is the one Executive page everyone can see.
  ...LEADERSHIP_TAB_IDS.filter((tabId) => tabId !== 'exec-dashboards'),
  'daily-ritual',
  'learning',
  'approvals',
  'dogfooding',
  'workflows',
  'google-business',
  'github',
  'agents',
  'skills',
  'notion-ai-tasks',
  'gtm',
  'pricing',
  'forward-coverage',
  'replenishment',
  'pricing-optimizer',
  'inventory-audit',
  'target-tna',
  'production-wip',
  'fulfillment',
  // 'operations-inventory',
  '3pl-audit',
  'milestones',
  'roadshows',
  'planograms',
  'shipbob-orders',
]);

export function canAccessAndrewOnlyTabs(email: string | null | undefined): boolean {
  return (email || '').trim().toLowerCase() === ANDREW_ONLY_EMAIL;
}

export function isAndrewOnlyTab(tabId: string): boolean {
  return ANDREW_ONLY_TAB_IDS.has(tabId);
}

/**
 * Access groups.
 *
 * Unlike the email check above, none of this hardcodes an identity: the answers
 * come from what /api/user/me served, which is derived from the same rows
 * AccessGroupMiddleware enforces on. That is deliberate -- a second list in the
 * frontend is how nav and enforcement drift apart, and a hidden sidebar item was
 * never a restriction anyway.
 */
type AccessUser = {
  access_group?: string | null;
  allowed_page_keys?: string[] | null;
} | null | undefined;

/** True when this user is confined to an access group. */
export function isRestrictedUser(user: AccessUser): boolean {
  return Boolean(user?.access_group);
}

/**
 * Whether a tab is visible to this user.
 *
 * Unrestricted users are unaffected, which is every account with no group.
 */
export function isPageAllowed(user: AccessUser, tabId: string): boolean {
  if (!isRestrictedUser(user)) return true;
  return (user?.allowed_page_keys ?? []).includes(tabId);
}

/**
 * The tab a restricted user should land on; null for unrestricted users.
 *
 * Without this a restricted user lands on the dashboard, whose own API calls are
 * denied, and sees a broken shell -- the first thing a new contractor would see.
 */
export function landingTabForUser(user: AccessUser): string | null {
  if (!isRestrictedUser(user)) return null;
  return (user?.allowed_page_keys ?? [])[0] ?? null;
}
